<div>
    <app-bussiness-type-form></app-bussiness-type-form>
</div>
<div>
    <app-bussiness-type-list></app-bussiness-type-list>
</div>